// extracted by mini-css-extract-plugin
export default {"root":"OrderList_root__+h28y","message":"OrderList_message__qja5K"};